import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import WhyCultureMatters from './components/WhyCultureMatters';
import Brands from './components/Brands';
import WhoShouldTake from './components/WhoShouldTake';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Admin from './components/Admin';
import CultureAssessmentPage from './CultureAssessmentPage';
import './App.css';

function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Brands />
        <WhoShouldTake />
        <Features />
        <WhyCultureMatters />
        <CTA />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/culture-assessment" element={<CultureAssessmentPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
